<script>
import axios from '~/services/axios';
import { VxSwal } from '@voxie/frontend-components';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons';
import { displayNotActiveModal } from '~/utils/team';

export default {
    inject: ['FEATURES'],
    /**
     * The application's data.
     */
    data() {
        return {
            user: Spark.state.user,
            teams: Spark.state.teams,
            currentTeam: Spark.state.currentTeam,
            loadingNotifications: false,
        };
    },

    /**
     * The component has been created by Vue.
     */
    created() {
        Bus.$on('updateUser', () => {
            this.getUser();
        });

        Bus.$on('updateTeams', () => {
            this.getTeams();
        });
    },

    /**
     * Prepare the application.
     */
    mounted() {
        this.whenReady();

        if (Spark.showEnableMFAModal) {
            VxSwal.fire({
                title: 'Two-Factor Authentication',
                html: `We strongly recommend to <a href="/settings#/security" class="font-bold">enable</a> two factor authentication.`,
                icon: faTriangleExclamation,
                iconColor: 'warning',
                confirmButtonColor: 'info',
                showCancelButton: true,
            }).then(({ value }) => {
                if (value) {
                    window.location.href = '/settings#/security';
                }
            });
        }

        // Let a chrome extension to know that core is loaded
        // This is some kind of two way communication using content scripts in the chrome extension.
        // We will sync a last core mount state with the chrome extension.
        // Would be good to add more some more events, like a feature flag disabling/enabling, etc.
        document.dispatchEvent(
            new CustomEvent('VoxieCore:OnMounted', {
                detail: {
                    FEATURES: this.FEATURES,
                },
            })
        );
    },

    methods: {
        /**
         * Finish bootstrapping the application.
         */
        whenReady() {
            if (this.shouldDisplayNotActivated()) {
                displayNotActiveModal();
            }
        },

        shouldDisplayNotActivated() {
            if (!this.currentTeam) {
                return false;
            }
            const sessionKey = `displayedNotActiveTeam.${this.currentTeam.id}`;

            const wasDisplayed = window.sessionStorage.getItem(sessionKey);

            if (this.isNotActive && !wasDisplayed) {
                window.sessionStorage.setItem(sessionKey, 1);
                return true;
            }

            return false;
        },

        /*
         * Get the current user of the application.
         */
        getUser() {
            axios.get('/user/current').then((response) => {
                this.user = response.data;
            });
        },

        /**
         * Get the current team list.
         */
        getTeams() {
            axios.get('/settings/teams').then((response) => {
                this.teams = response.data;
            });
        },

        /**
         * Get the current team.
         */
        getCurrentTeam() {
            axios
                .get(`/settings/teams/current`)
                .then((response) => {
                    this.currentTeam = response.data;
                })
                .catch(() => {
                    //
                });
        },
    },

    computed: {
        isNotActive() {
            return Spark.state.currentTeam.status !== 'active';
        },
    },
};
</script>
